import _ from 'lodash'
import GraphqlBuilder from 'utils/request/graphql/builder'
import MutationEmployeeBookingStatus from 'graphql/mutations/MutationEmployeeBookingStatus'
import { constantsActive } from 'utils/constants/constants'
import FetchCachedMyBooking from 'utils/fetch/cached/FetchCachedMyBooking'
import { resetCart } from 'services/redux/cart/actions'
import store from 'services/redux/store'
import { dataConstants } from 'services/redux/data/constants'
import HelperTimeslot from 'utils/helper-timeslot'
import HelperTimeslotKinds from 'utils/helper-timeslot-kinds'
import ObjectTimeslot from 'utils/objects/timeslot'

const mutationCancelBooking = ( booking, callback ) => {
	if( !_.isFunction( callback ) ) {
		callback = () => {
			store.dispatch( resetCart() )
		}
	}
	
	new GraphqlBuilder()
		.addQuery( 'booking_cancel', MutationEmployeeBookingStatus, {
			guid: booking.guid,
			active: constantsActive.NO
		})
		.setOnSuccess( result => {
			FetchCachedMyBooking.reload({
				callbackSuccess: bookings => {
					if( _.isFunction( callback ) ) {
						callback( bookings )
					}
					
					store.dispatch( resetCart() )
				},
				callbackError: callback
			});
		})
		.setOnError( callback )
		.execute();
}

export const createBookingActions = ( booking, actions = {} ) => {
	// Init the actions
	let actionResults = {
		cancelable: null
	}
	
	// Find the action
	const customCancelAction = _.get( actions, 'cancelAction', null );
	const customCancelActionAvailable = customCancelAction !== null && _.isFunction( customCancelAction );
	if( customCancelActionAvailable ) {
		return {
			...actionResults,
			cancelable: {
				enabled: customCancelActionAvailable,
				function: customCancelAction.bind( this, booking )
			}
		}
	}
	
	// Get the cancel time
	const timeslotKind = store.getState().data[ dataConstants.TIMESLOT_KINDS ][ HelperTimeslot.combineKindSubKind( booking.timeslot ) ];
	const timeslotKindCanCancelUntil = _.get( timeslotKind, 'can_cancel_until', 'always' ) ?? 'always';
	const { can: timeslotCanCancelUntil } = HelperTimeslotKinds.canCancel( booking, timeslotKindCanCancelUntil, ObjectTimeslot.getCapacity( booking ) );
	
	if( timeslotCanCancelUntil ) {
		return {
			...actionResults,
			cancelable: {
				enabled: timeslotCanCancelUntil,
				function: mutationCancelBooking.bind( this, booking )
			}
		}
	}
	
	return actionResults;
}
